"use client";
import React, { useState } from "react";
import { PieChart } from "@carbon/charts-react";
import CustomCard from "./CustomCard";

const CompanySnapshot = () => {
  //   const [chartData, setChartData] = useState([]);
  const [chartDataError, setChartDataError] = useState(false);
  const [documentsSelection, setDocumentsSelection] =
    useState("Annual reports");

  const handleDocumentsClick = (pe) => {
    setDocumentsSelection(pe);
  };
  const res = [
    {
      name: "foreign_institution",
      value: 22000,
    },
    {
      name: "domestic_institution",
      value: 53436.4,
    },
    {
      name: "government",
      value: 78400,
    },
    {
      name: "public",
      value: 28400,
    },
  ];
  const updatedResponse = res.map((item) => {
    let updatedValue;
    switch (item.name) {
      case "domestic_institution":
        updatedValue = "Domestic Institution";
        break;
      case "government":
        updatedValue = "Government";
        break;
      case "public":
        updatedValue = "Public";
        break;
      case "foreign_institution":
        updatedValue = "Foreign Institutions";
        break;
      default:
        updatedValue = item.name;
    }

    return {
      group: updatedValue,
      value: item.value,
    };
  });

  const res1 = [
    {
      group: "Treasury",
      value: 22000,
    },
    {
      group: "Wholesale banking",
      value: 53436.4,
    },
    {
      group: "Retail banking",
      value: 78400,
    },
    {
      group: "Other banking operations",
      value: 28400,
    },
  ];
  const res2 = [
    {
      group: "Domestic",
      value: 22000,
    },
    {
      group: "International",
      value: 53436.4,
    },
  ];
  const res3 = [
    {
      group: "Retail",
      value: 22000,
    },
    {
      group: "Wholesale",
      value: 53436.4,
    },
    {
      group: "CRB",
      value: 33436.4,
    },
  ];
  const res4 = [
    {
      group: "Agriculture and allied activities",
      value: 22000,
    },
    {
      group: "Personal Loans",
      value: 53436.4,
    },
    {
      group: "Advances to industries eligible",
      value: 33436.4,
    },
    {
      group: "Services",
      value: 29436.4,
    },
  ];
  const res5 = [
    {
      group: "Advances",
      value: 22000,
    },
    {
      group: "Deposits",
      value: 53436.4,
    },
    {
      group: "Acquiring volumes ",
      value: 33436.4,
    },
    {
      group: "Credit Cards",
      value: 29436.4,
    },
  ];

  const options = {
    resizable: true,
    height: "170px",
    pie: {
      innerRadius: 0,
    },
    toolbar: {
      enabled: false,
    },
    legend: {
      position: "right",
      alignment: "center",
    },
    color: {
      scale: [
        "#66A9E4",
        "#F7A452",
        "#6C87C8",
        "#26ABA4",
        "#9D53F2",
        "#0070D2",
        "#E8787D",
      ],
    },
  };
  const cardColors = ["#EAF4F4", "#F4EDEA", "#EDEAF4"];
  const documentsDummy = [
    { name: "Financial year 2023", institution: "from BSE" },
    { name: "Financial year 2022", institution: "from BSE" },
    { name: "Financial year 2021", institution: "from BSE" },
    { name: "Financial year 2020", institution: "from BSE" },
    { name: "Financial year 2019", institution: "from BSE" },
  ];
  const documentsDummy1 = [
    { name: "Rating Update ", institution: "from CARE", date: "7 Mar'24" },
    { name: "Rating Update ", institution: "from Fitch", date: "5 Dec'24" },
    { name: "Rating Update", institution: "from CARE", date: "10 Mar '24" },
    { name: "Rating Update ", institution: "from Fitch", date: "20 Dec'24" },
    { name: "Rating Update ", institution: "from CARE", date: "15 Mar'24" },
  ];
  const documentsDummy2 = [
    {
      date: "Apr 2024",
    },
    {
      date: "May 2024",
    },
    {
      date: "June 2024",
    },
    {
      date: "July 2024",
    },
    {
      date: "Aug 2024",
    },
    {
      date: "Sep 2024",
    },
  ];
  const [downloadedDocuments, setDownloadedDocuments] = useState({});
  const [showAllAnnualReports, setShowAllAnnualReports] = useState(false);
  const [showAllCreditRatings, setShowAllCreditRatings] = useState(false);
  const [showAllConcall, setShowAllConcall] = useState(false);

  const initialDocumentsToShow = 3;
  const documentsToDisplay = showAllAnnualReports
    ? documentsDummy
    : documentsDummy.slice(0, initialDocumentsToShow);

  const documentsToDisplay1 = showAllCreditRatings
    ? documentsDummy1
    : documentsDummy1.slice(0, initialDocumentsToShow);

  const documentsToDisplay2 = showAllConcall
    ? documentsDummy2
    : documentsDummy2.slice(0, initialDocumentsToShow);

  const handleDocumentsDownload = (documentName) => {
    setDownloadedDocuments((prev) => ({ ...prev, [documentName]: true }));
    setTimeout(() => {
      setDownloadedDocuments((prev) => ({ ...prev, [documentName]: false }));
    }, 6000); // Set the duration of the GIF animation in milliseconds
  };
  return (
    <div className="flex flex-col m-4 ">
      <p className="text-[#333333] font-bold  text-2xl mb-4">
        Company Snapshot
      </p>
      {/* <div className="flex gap-4">
        <div className="flex flex-col border border-solid border-[#E0E0E0] rounded-lg p-4 w-[589px]">
          <p className="font-semibold text-sm text-[#333333] mb-3">
            About Company
          </p>
          <p className="font-medium text-sm text-[#8B8B8B]">
            The Housing Development Finance Corporation Limited (HDFC) was
            amongst the first to receive an &apos;in principle&apos; approval
            from the Reserve Bank of India (RBI) to set up a bank in the private
            sector. HDFC Bank is a publicly held banking company, the bank was
            incorporated in August 1994 in the name of &apos;HDFC Bank
            Limited&apos;, with its registered office in Mumbai, India. It is
            engaged in providing a range of banking and financial services
            including retail banking, wholesale banking and treasury operations.
            It is promoted by HDFC Ltd. which has 19.32% stake as on September
            30, 2020. Currently, HDFC Bank Ltd. (HBL) is the largest private
            sector bank in India.
          </p>
        </div>
        <div className="border border-solid border-[#E0E0E0] rounded-lg p-4 w-[400px]   ">
          <p className="font-semibold text-sm text-[#333333]">
            Shareholding Pattern
          </p>
          {!chartDataError && (
            <PieChart data={updatedResponse} options={options}></PieChart>
          )}
        </div>
      </div> */}
      <div className="flex flex-col border border-solid overflow-x-auto no-scrollbar border-[#E0E0E0] rounded-lg p-4 mt-4">
        <p className="text-sm font-semibold mb-3">Key Points</p>
        <div className="flex flex-row gap-4">
          <div className="border flex flex-col gap-2 border-solid border-[#E0E0E0] rounded-lg p-4 w-[275px] min-w-[275px] h-[229px] bg-[#EAF4EC]">
            <p className="font-bold text-xs mb-3">Key Information</p>
            <div className="flex justify-between ">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">Market Cap</p>
                <p className="font-bold text-xs text-[#333333]">65556</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Current Price
                </p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  65455
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  52 Week High
                </p>
                <p className="font-bold text-xs text-[#333333]">5556</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  52 Week Low
                </p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  3555
                </p>
              </div>
            </div>{" "}
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Dividend Yield
                </p>
                <p className="font-bold text-xs text-[#333333] ">1.32%</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">Face Value</p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  1.00
                </p>
              </div>
            </div>
          </div>{" "}
          <div className="border flex flex-col gap-2 border-solid border-[#E0E0E0] rounded-lg p-4 w-[275px] min-w-[275px] h-[229px] bg-[#EDEAF4]">
            <p className="font-bold text-xs ">Key Ratios</p>
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]  whitespace-nowrap overflow-hidden text-ellipsis w-[100px]">
                  Capital Adequacy Ratio
                </p>
                <p className="font-bold text-xs text-[#333333]">18.9%</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]  whitespace-nowrap overflow-hidden text-ellipsis w-[100px]">
                  Net Interest Margin
                </p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  3.89%
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">Gross NPA</p>
                <p className="font-bold text-xs text-[#333333]">1.24%</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">CASA Ratio</p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  48%
                </p>
              </div>
            </div>{" "}
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Cost to Income ratio
                </p>
                <p className="font-bold text-xs text-[#333333] ">38.32%</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">ROE</p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  22.00
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">ROCE</p>
                <p className="font-bold text-xs text-[#333333] ">9.32%</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">PE Ratio</p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  17.50
                </p>
              </div>
            </div>
          </div>{" "}
          <CustomCard
            title={"Segment Revenue "}
            chartData={res1}
            bgcolor={cardColors[0]}
          />
          <CustomCard
            title={"Location-wise Breakup "}
            chartData={res2}
            bgcolor={cardColors[1]}
          />
          <CustomCard
            title={"Loan Mix "}
            chartData={res3}
            bgcolor={cardColors[2]}
          />
          <CustomCard
            title={"Sector-wide Loan Breakup "}
            chartData={res4}
            bgcolor={cardColors[0]}
          />
          <CustomCard
            title={"Market Share"}
            chartData={res5}
            bgcolor={cardColors[1]}
          />
          <div className="border flex flex-col gap-2 border-solid border-[#E0E0E0] rounded-lg p-4 w-[275px] min-w-[275px] h-[229px] bg-[#EDEAF4]">
            <p className="font-bold text-xs mb-3">Reach</p>
            <div className="flex justify-between ">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Customer Base
                </p>
                <p className="font-bold text-xs text-[#333333]">70 Mn+</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Banking Branches
                </p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  6.3K+
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Banking Outlets
                </p>
                <p className="font-bold text-xs text-[#333333]">21k+</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="font-medium text-xs text-[#8B8B8B]">
                  Balance sheet size
                </p>
                <p className="font-bold text-xs text-[#333333] text-right">
                  20,68535Cr
                </p>
              </div>
            </div>{" "}
          </div>{" "}
        </div>
      </div>
      <div className="border border-solid border-[#E0E0E0] rounded-lg p-4 mt-4 w-[401px] flex flex-col ">
        <p className="text-sm font-semibold text-[#333333]">Documents</p>
        <div className="flex justify-center items-center">
          <div className="flex justify-between items-center mt-4 rounded-full w-[80%] bg-[#F1F1F6]">
            <button
              onClick={() => handleDocumentsClick("Annual reports")}
              className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                documentsSelection === "Annual reports"
                  ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                  : ""
              }`}
            >
              Annual reports
            </button>
            <button
              className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                documentsSelection === "Credit ratings"
                  ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                  : ""
              }`}
              onClick={() => handleDocumentsClick("Credit ratings")}
            >
              Credit ratings
            </button>
            <button
              className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                documentsSelection === "Concalls"
                  ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                  : ""
              }`}
              onClick={() => handleDocumentsClick("Concalls")}
            >
              Concalls
            </button>
          </div>
        </div>

        {documentsSelection === "Annual reports" ? (
          <div>
            {documentsToDisplay.map((document, index) => (
              <div
                key={index}
                className="flex flex-row items-center gap-4 mt-3 border-b "
              >
                <img
                  alt=""
                  src="/images/pdfLogo.png"
                  className="w-[42px] h-[42px] mb-2"
                />
                <div className="flex flex-col">
                  <p className="text-xs font-bold w-[260px]">{document.name}</p>
                  <p className="text-[10px] text-[#d8d8d8]">
                    {document.institution}
                  </p>
                </div>
                <div className="w-[40px]">
                  {!downloadedDocuments[document.name] ? (
                    <img
                      src="/images/downloadLogo.png"
                      alt="Download"
                      className="w-[20px] h-[20px] cursor-pointer"
                      onClick={() => handleDocumentsDownload(document.name)}
                    />
                  ) : (
                    <img
                      src="/images/Animation.gif"
                      alt="Downloading"
                      className="w-[30px] h-[30px]"
                    />
                  )}
                </div>
              </div>
            ))}
            {!showAllAnnualReports &&
              documentsDummy.length > initialDocumentsToShow && (
                <div className="flex flex-row gap-2 items-center pt-3 justify-center">
                  <button
                    className=" text-xs font-medium text-[#656565]"
                    onClick={() => setShowAllAnnualReports(true)}
                  >
                    Show More
                  </button>
                  <img
                    src="/images/rightArrow.png"
                    alt=""
                    className="w-[12px] h-[12px]"
                  />
                </div>
              )}
          </div>
        ) : documentsSelection === "Credit ratings" ? (
          <div>
            {documentsToDisplay1.map((document, index) => (
              <div
                key={index}
                className="flex flex-row items-center gap-4 mt-3 border-b "
              >
                <img
                  alt=""
                  src="/images/pdfLogo.png"
                  className="w-[42px] h-[42px] mb-2"
                />
                <div className="flex flex-col">
                  <p className="text-xs font-bold w-[260px]">{document.name}</p>
                  <div className="flex flex-row gap-4">
                    <p className="text-[10px] font-medium text-[#8B8B8B]">
                      {document.date}
                    </p>{" "}
                    <p className="text-[10px] font-medium text-[#8B8B8B]">
                      {document.institution}
                    </p>
                  </div>
                </div>
                <div className="w-[40px]">
                  {!downloadedDocuments[document.name] ? (
                    <img
                      src="/images/downloadLogo.png"
                      alt="Download"
                      className="w-[20px] h-[20px] cursor-pointer"
                      onClick={() => handleDocumentsDownload(document.name)}
                    />
                  ) : (
                    <img
                      src="/images/Animation.gif"
                      alt="Downloading"
                      className="w-[30px] h-[30px]"
                    />
                  )}
                </div>
              </div>
            ))}
            {!showAllCreditRatings &&
              documentsDummy1.length > initialDocumentsToShow && (
                <div className="flex flex-row gap-2 items-center pt-3 justify-center">
                  <button
                    className=" text-xs font-medium text-[#656565]"
                    onClick={() => setShowAllCreditRatings(true)}
                  >
                    Show More
                  </button>
                  <img
                    src="/images/rightArrow.png"
                    alt=""
                    className="w-[12px] h-[12px]"
                  />
                </div>
              )}
          </div>
        ) : documentsSelection === "Concalls" ? (
          <div>
            {documentsToDisplay2.map((document, index) => (
              <div
                key={index}
                className="flex flex-row items-center gap-4 mt-3 border-b "
              >
                <img
                  alt=""
                  src="/images/pdfLogo.png"
                  className="w-[42px] h-[42px] mb-2"
                />
                <div className="flex flex-col justify-between">
                  <p className="text-xs font-bold w-[160px]">{document.date}</p>
                </div>
                <div className="">
                  {!downloadedDocuments[document.date] ? (
                    <div className="border border-[#00394d] rounded items-center flex gap-2 flex-row ml-10 py-[3px] px-2 cursor-pointer">
                      <img
                        src="/images/downloadDown.png"
                        alt="Download"
                        className="w-[12px] h-[12px] "
                        onClick={() => handleDocumentsDownload(document.date)}
                      />
                      <p className="text-[10px] font-semibold text-[#00394d]">
                        {" "}
                        Transcript
                      </p>
                    </div>
                  ) : (
                    <img
                      src="/images/Animation.gif"
                      alt="Downloading"
                      className="w-[30px] h-[30px]"
                    />
                  )}
                </div>
              </div>
            ))}
            {!showAllConcall &&
              documentsDummy2.length > initialDocumentsToShow && (
                <div className="flex flex-row gap-2 items-center pt-3 justify-center">
                  <button
                    className=" text-xs font-medium text-[#656565]"
                    onClick={() => setShowAllConcall(true)}
                  >
                    Show More
                  </button>
                  <img
                    src="/images/rightArrow.png"
                    alt=""
                    className="w-[12px] h-[12px]"
                  />
                </div>
              )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CompanySnapshot;
